import {
  LOAD_CUSTOMER,
  LOAD_CUSTOMER_DATA,
  LOAD_CUSTOMER_DATA_FAILURE,
  CLEAR_CUSTOMER_REQUEST,
  GET_CUSTOMERS_REQUEST,
  GET_CUSTOMERS_SUCCESS,
  GET_CUSTOMERS_FAILURE,
  GET_CUSTOMER_DETAILS_REQUEST,
  GET_CUSTOMER_DETAILS_SUCCESS,
  GET_CUSTOMER_DETAILS_FAILURE,
  GET_CUSTOMER_DETAILS_CLEAR,
  GET_ALL_CUSTOMER_LINKS_REQUEST,
  GET_ALL_CUSTOMER_LINKS_SUCCESS,
  GET_ALL_CUSTOMER_LINKS_FAILURE,
  ADD_CUSTOMER_LINK_REQUEST,
  ADD_CUSTOMER_LINK_SUCCESS,
  ADD_CUSTOMER_LINK_FAILURE,
  SUPPORTING_DOC_ADDED,
  SUPPORTING_DOC_DELETE_REQUEST,
  SUPPORTING_DOC_DELETE_SUCCESS,
  SUPPORTING_DOC_DELETE_FAILURE,
  ADD_CUSTOMER_ACCOUNT_REQUEST,
  ADD_CUSTOMER_ACCOUNT_SUCCESS,
  ADD_CUSTOMER_ACCOUNT_FAILURE,
  GET_BASIC_CUSTOMER_REQUEST,
  GET_BASIC_CUSTOMER_SUCCESS,
  GET_BASIC_CUSTOMER_FAILURE,
  GET_BASIC_ACCOUNT_REQUEST,
  GET_BASIC_ACCOUNT_SUCCESS,
  GET_BASIC_ACCOUNT_FAILURE,
  ADD_CUSTOMER_ACCOUNT_CLEAR_ACCOUNT,
  ADD_CUSTOMER_ACCOUNT_CLEAR_CUSTOMER,
  EDIT_CUSTOMER,
  EDIT_CUSTOMER_CANCEL,
  UPDATE_CUSTOMER_REQUEST,
  UPDATE_CUSTOMER_SUCCESS,
  UPDATE_CUSTOMER_ERROR,
  OPEN_ADD_CUSTOMER_ADDRESS_MODAL,
  CLOSE_ADD_CUSTOMER_ADDRESS_MODAL,
  OPEN_ADD_CUSTOMER_JOTR_MODAL,
  CLOSE_ADD_CUSTOMER_JOTR_MODAL,
  CHANGE_PRIMARY_ADDRESS_REQUEST,
  CHANGE_PRIMARY_ADDRESS_SUCCESS,
  CHANGE_PRIMARY_ADDRESS_FAILURE,
  CHANGE_PRIMARY_JOTR_REQUEST,
  CHANGE_PRIMARY_JOTR_SUCCESS,
  CHANGE_PRIMARY_JOTR_FAILURE,
} from 'actions';

// eslint-disable-next-line default-param-last
function customer(state = {
  isLoadingData: false,
  storeCustomer: null,
  isCustomerIdChangeModalShown: false,
  returnedExistingCustomerId: '',
  isGettingCustomers: false,
  customers: [],
  customerSupportingDocs: [],
  isDeletingSupportingDocId: null,
  supportingDocError: null,
  customersCount: 0,
  getCustomerDetailsError: null,
  basicCustomer: null,
  basicAccount: null,
  basicCustomerError: null,
  basicAccountError: null,
  isGettingBasicAccount: false,
  isGettingBasicCustomer: false,
  isEditingCustomer: false,
  isSubmittingCustomer: false,
  isCustomerEditSuccess: false,
  isAddCustomerAddressModalShown: false,
  isAddCustomerJotrModalShown: false,
  isChangingPrimaryAddress: false,
  isChangingPrimaryJotr: false,
  isChangingWhdJotr: false
}, action) {
  switch (action.type) {
    case LOAD_CUSTOMER:
      return {
        ...state,
        isLoadingData: false,
        storeCustomer: action.storeCustomer,
        customerSupportingDocs: [...action.storeCustomer.supportingDocs]
      };
    case SUPPORTING_DOC_ADDED:
      return {
        ...state,
        isLoadingData: false,
        customerSupportingDocs: [...state.customerSupportingDocs, ...action.newSupportingDoc],
      };
    case SUPPORTING_DOC_DELETE_REQUEST:
      return {
        ...state,
        isDeletingSupportingDocId: action.isDeletingSupportingDocId,
      };
    case SUPPORTING_DOC_DELETE_SUCCESS:
      return {
        ...state,
        isDeletingSupportingDocId: null,
        customerSupportingDocs: state.customerSupportingDocs ? state.customerSupportingDocs.filter(doc => doc.id !== action.isDeletingSupportingDocId) : state.customerSupportingDocs
      };
    case SUPPORTING_DOC_DELETE_FAILURE:
      return {
        ...state,
        isDeletingSupportingDocId: action.isDeletingSupportingDocId,
        supportingDocError: action.supportingDocError
      };
    case LOAD_CUSTOMER_DATA:
      return {
        ...state,
        isLoadingData: true,
        storeCustomer: null,
        customerDataLoadError: null
      };
    case LOAD_CUSTOMER_DATA_FAILURE:
      return {
        ...state,
        isLoadingData: false,
        customerDataLoadError: action.customerDataLoadError
      };
    case CLEAR_CUSTOMER_REQUEST:
      return {
        ...state,
        isLoadingData: false,
        storeCustomer: null
      };
    case GET_CUSTOMERS_REQUEST:
      return {
        ...state,
        isGettingCustomers: action.isGettingCustomers
      };
    case GET_CUSTOMERS_SUCCESS:
      return {
        ...state,
        isGettingCustomers: action.isGettingCustomers,
        customers: action.customers,
        customersCount: action.customersCount
      };
    case GET_CUSTOMERS_FAILURE:
      return {
        ...state,
        isGettingCustomers: action.isGettingCustomers,
        customers: [],
        customersCount: 0
      };
    case GET_CUSTOMER_DETAILS_REQUEST:
      // eslint-disable-next-line no-case-declarations
      const requestCustomers = state.customers.filter((c, i) => c.id === action.customerId && i === action.rowId);

      if (requestCustomers && requestCustomers.length === 1) {
        requestCustomers[0].isLoadingDetails = true;
      }

      return {
        ...state,
        getCustomerDetailsError: null,
        customers: state.customers.concat([])
      };
    case GET_CUSTOMER_DETAILS_SUCCESS:
      // eslint-disable-next-line no-case-declarations
      const matchedCustomers = state.customers.filter((c, i) => c.id === action.customerId && i === action.rowId);

      if (matchedCustomers && matchedCustomers.length === 1) {
        matchedCustomers[0].additionalData = action.customerDetails;
        matchedCustomers[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCustomerDetailsError: null,
        customers: state.customers.concat([])
      };
    case GET_CUSTOMER_DETAILS_FAILURE:
      // eslint-disable-next-line no-case-declarations
      const failureCustomers = state.customers.filter((c, i) => c.id === action.customerId && i === action.rowId);

      if (failureCustomers && failureCustomers.length === 1) {
        failureCustomers[0].additionalData = null;
        failureCustomers[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCustomerDetailsError: action.getCustomerDetailsError,
        customers: state.customers.concat([])
      };
    case GET_CUSTOMER_DETAILS_CLEAR:
      // eslint-disable-next-line no-case-declarations
      const clearCustomers = state.customers.filter((c, i) => c.id === action.customerId && i === action.rowId);

      if (clearCustomers && clearCustomers.length === 1) {
        clearCustomers[0].additionalData = null;
        clearCustomers[0].isLoadingDetails = false;
      }

      return {
        ...state,
        getCustomerDetailsError: null,
        customers: state.customers.concat([])
      };
    case GET_ALL_CUSTOMER_LINKS_REQUEST:
      return {
        ...state,
        isGettingCustomerLinks: true
      };
    case GET_ALL_CUSTOMER_LINKS_SUCCESS:
      return {
        ...state,
        storeCustomer: {
          ...state.storeCustomer,
          links: action.customerLinks.links,
          linksFrom: action.customerLinks.linksFrom
        },
        isGettingCustomerLinks: false,
      };
    case GET_ALL_CUSTOMER_LINKS_FAILURE:
      return {
        ...state,
        isGettingCustomerLinks: false,
      };
    case ADD_CUSTOMER_LINK_REQUEST:
      return {
        ...state,
        isAddingCustomerLink: true
      };
    case ADD_CUSTOMER_LINK_SUCCESS:
      return {
        ...state,
        isAddingCustomerLink: false,
      };
    case ADD_CUSTOMER_LINK_FAILURE:
      return {
        ...state,
        isAddingCustomerLink: false,
      };
    case ADD_CUSTOMER_ACCOUNT_REQUEST:
      return {
        ...state,
        isAddingCustomerAccount: action.isAddingCustomerAccount
      };
    case ADD_CUSTOMER_ACCOUNT_SUCCESS:
      return {
        ...state,
        isAddingCustomerAccount: action.isAddingCustomerAccount,
        AddingCustomerAccountSuccess: true,
        basicCustomer: null,
        basicAccount: null
      };
    case ADD_CUSTOMER_ACCOUNT_FAILURE:
      return {
        ...state,
        AddingCustomerAccountSuccess: false
      };
    case GET_BASIC_CUSTOMER_SUCCESS:
      return {
        ...state,
        isGettingBasicCustomer: false,
        basicCustomer: action.basicCustomer
      };
    case GET_BASIC_CUSTOMER_REQUEST:
      return {
        ...state,
        isGettingBasicCustomer: true,
        basicCustomer: null,
        basicCustomerError: null
      };
    case GET_BASIC_CUSTOMER_FAILURE:
      return {
        ...state,
        isGettingBasicCustomer: false,
        basicCustomerError: action.basicCustomerError
      };
    case GET_BASIC_ACCOUNT_SUCCESS:
      return {
        ...state,
        isGettingBasicAccount: false,
        basicAccount: action.basicAccount
      };
    case GET_BASIC_ACCOUNT_REQUEST:
      return {
        ...state,
        isGettingBasicAccount: true,
        basicAccount: null,
        basicAccountError: null
      };
    case GET_BASIC_ACCOUNT_FAILURE:
      return {
        ...state,
        isGettingBasicAccount: false,
        basicAccountError: action.basicAccountError
      };
    case ADD_CUSTOMER_ACCOUNT_CLEAR_ACCOUNT:
      return {
        ...state,
        basicAccount: null
      };
    case ADD_CUSTOMER_ACCOUNT_CLEAR_CUSTOMER:
      return {
        ...state,
        basicCustomer: null
      };
    case EDIT_CUSTOMER:
      return {
        ...state,
        isEditingCustomer: true,
        isCustomerEditSuccess: false
      };
    case EDIT_CUSTOMER_CANCEL:
      return {
        ...state,
        isEditingCustomer: false,
        isCustomerEditSuccess: false
      };
    case UPDATE_CUSTOMER_REQUEST:
      return {
        ...state,
        isEditingCustomer: true,
        isCustomerEditSuccess: false
      };
    case UPDATE_CUSTOMER_SUCCESS:
    {
      // eslint-disable-next-line no-case-declarations
      const { storeCustomer } = state;

      return {
        ...state,
        storeCustomer,
        isEditingCustomer: false,
        isSubmittingCustomer: false,
        isCustomerEditSuccess: true
      };
    }
    case UPDATE_CUSTOMER_ERROR:
      return {
        ...state,
        isEditingCustomer: true,
        isSubmittingCustomer: false,
        isCustomerEditSuccess: false
      };
    case OPEN_ADD_CUSTOMER_ADDRESS_MODAL:
      return {
        ...state,
        isAddCustomerAddressModalShown: true,
      };
    case CLOSE_ADD_CUSTOMER_ADDRESS_MODAL:
      return {
        ...state,
        isAddCustomerAddressModalShown: false
      };
    case OPEN_ADD_CUSTOMER_JOTR_MODAL:
      return {
        ...state,
        isAddCustomerJotrModalShown: true
      };
    case CLOSE_ADD_CUSTOMER_JOTR_MODAL:
      return {
        ...state,
        isAddCustomerJotrModalShown: false,
      };
    case CHANGE_PRIMARY_ADDRESS_REQUEST:
      return {
        ...state,
        isChangingPrimaryAddress: true,
      };
    case CHANGE_PRIMARY_ADDRESS_SUCCESS:
    {
      // eslint-disable-next-line no-case-declarations
      const { storeCustomer } = state;

      if (storeCustomer && action.addresses) {
        storeCustomer.addresses = action.addresses;
        storeCustomer.permanentAddresses = action.addresses.filter(x => x.addressType === 1);
        storeCustomer.mailingAddresses = action.addresses.filter(x => x.addressType === 2);
      }

      return {
        ...state,
        storeCustomer: { ...storeCustomer },
        isChangingPrimaryAddress: false,
      };
    }
    case CHANGE_PRIMARY_ADDRESS_FAILURE:
      return {
        ...state,
        isChangingPrimaryAddress: false,
      };
    case CHANGE_PRIMARY_JOTR_REQUEST:
      return {
        ...state,
        isChangingPrimaryJotr: true,
      };
    case CHANGE_PRIMARY_JOTR_SUCCESS:
    {
      // eslint-disable-next-line no-case-declarations
      const { storeCustomer } = state;

      if (storeCustomer && action.jotrs) {
        storeCustomer.taxResidencies = action.jotrs;
      }

      return {
        ...state,
        storeCustomer: { ...storeCustomer },
        isChangingPrimaryJotr: false,
      };
    }
    case CHANGE_PRIMARY_JOTR_FAILURE:
      return {
        ...state,
        isChangingPrimaryJotr: false,
      };
    default:
      return state;
  }
}

export default customer;
